import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["DialogContent"], _mergeProps($setup.forwarded, {
        class: $setup.cn('bg-background fixed left-1/2 top-1/2 z-1010 grid max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border shadow-xl origin-center', 'duration-300 ease-out', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0', 'data-[state=open]:zoom-in-[98%] data-[state=closed]:zoom-out-[98%]', 'sm:rounded-lg', $setup.props.class)
    }), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"]));
}
